import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKey } from '../../i18n/translationKeys';
import { RetainedContent } from '../../ui/RetainedContent/RetainedContent';
import type { RelanceSectionProps } from './types';

export const RelanceSection: React.FC<RelanceSectionProps> = ({ id, title, titleHidden = false, count, loading, error, errorTestId, errorAction, skeleton, children }) => {
    const { t } = useTranslation();
    const headingId = `home-section-heading-${id}`;

    return (
        <section aria-labelledby={headingId} data-testid={`home-section-${id}`} className="flex flex-col gap-m">
            <h2 id={headingId} className={titleHidden ? 'sr-only' : 'text-block-title text-content'}>
                {title}
                <span
                    className="ml-xs text-xs font-normal"
                    aria-label={t(TranslationKey.Home.Tabs.BadgeAriaLabel, { count })}
                    data-testid={`home-section-badge-${id}`}
                >
                    ({count})
                </span>
            </h2>
            {loading ? (
                skeleton
            ) : error ? (
                <div className="flex flex-col gap-s">
                    <p data-testid={errorTestId ?? `home-section-error-${id}`} className="text-s text-danger">{error}</p>
                    {errorAction}
                </div>
            ) : null}
            {/* Hidden, not unmounted, so a modal opened from the list keeps what was typed across a refresh. */}
            <RetainedContent hidden={loading || error != null}>{children}</RetainedContent>
        </section>
    );
};
